export const ROLE_HIERARCHY: Record<string, string[]> = {
  Super: ['Super', 'Admin', 'Manager', 'Staff'],
  Admin: ['Admin', 'Manager', 'Staff'],
  Manager: ['Manager', 'Staff'],
  Staff: ['Staff'],
};
